import { DataSchemaItemFragment, JobCatalogTreeFragment } from 'generated/resources/graphql'
import {
  ContractsAnnualWorkingTimeDistributionEnum,
  ContractsBankHolidayTreatmentEnum,
} from 'generated/resources/graphql'

import type LegalEntity from 'modules/core/store/models/LegalEntity'

export type WizardData = {
  contractVersionStartsOn?: string
  firstName?: string
  lastName?: string
  email?: string
  isValidEmail?: boolean
  legalEntity?: LegalEntity
  legalEntityCountry?: string
  legalEntityId?: string
  employeeGroupId?: string
  roleId?: string
  jobLevelId?: string
  jobCatalogTreeNodeUuid?: string
  roleLevelName?: string
  salaryAmount?: string
  contractsSalaryFrequency?: string
  isSalaryValid?: boolean
  teamId?: string
  teamIds?: string[]
  withOnboarding?: boolean
  onboardingProcessId?: string
  payrollPolicyId?: string
  source?: EmployeeSource
  hasPayrollApp?: boolean
  hasCompensationsManagement?: boolean
  hasJobCatalog?: boolean
  canAssignManager?: boolean
  canInviteUserToFactorial?: boolean
  canAssignWorkflow?: boolean
  canAssignPermissionGroup?: boolean
  workplaceId?: string
  locationId?: string
  defaultWorkAreaId?: string
  socialSecurityNumber?: string
  socialSecurityNumberValid?: boolean
  identifier?: string
  identifierType?: string
  identifierValid?: boolean
  identifierExpirationDate?: string
  birthdayOn?: string
  phoneNumber?: string
  nationality?: string
  gender?: string
  addressLine1?: string
  city?: string
  postalCode?: string
  state?: string
  country?: string
  workingHours?: string
  workingHoursFrequency?: string
  workingDays?: string
  contractsEsContractTypeId?: string
  contractsEsWorkingDayTypeId?: string
  contractsEsProfessionalCategoryId?: string
  contractsEsContributionTypeId?: string
  contractsFrContractTypeId?: string
  contractsFrProfessionalCategoryId?: string
  contractsPtContractTypeId?: string
  contractsDeContractTypeId?: string
  contractsDeBaseSalaryTypeId?: string
  startDate?: string
  contractsStartsOn?: string
  contractsEndsOn?: string
  sendInvitation?: boolean
  hasTrialPeriod?: boolean
  trialPeriodEndsOn?: string
  companyId?: string
  enableEmployeeOnboarding?: boolean
  managerId?: string
  timeoffManagerId?: string
  permissionsGroupId?: string
  fieldsSchema?: DataSchemaItemFragment[]
  bankNumber?: string
  bankNumberFormat?: string
  swiftBic?: string
  contractsBankHolidayTreatment?: ContractsBankHolidayTreatmentEnum
  contractsWorkingTimePercentageInCents?: number
  contractsMaxLegalYearlyHours?: string
  contractsMaximumWeeklyHours?: number
  hasDevTimeTrackingWorkableDaysDefinition?: boolean
  hasDevTimeoffWorkConditions?: boolean
  hasTimeTrackingAnnualisationDailyValue?: boolean
  contractsAnnualWorkingTimeDistribution?: ContractsAnnualWorkingTimeDistributionEnum
  hasDevJobCatalogTree?: boolean
  hasFixedDiscontinuousContracts?: boolean
  jobCatalogTrees?: JobCatalogTreeFragment[]
  contractIsDiscontinuous?: boolean
  selectedDevices?: Device[]
  selectedDevicesContext?: {
    nodeId?: string | null
    roleLevelName?: string | null
  }
  validDevices?: boolean
  requestedDeviceAssets?: string[]
  requestedDevicesResponsibleEmployeeIds?: string[]
  requestedDevicesNotes?: string
  contractsEsAgreementCodeId?: string
}

export interface Device {
  id: string
  itAssetModelId: string
  name: string
  brand: string
  type: string
  itAssetId?: string
  serialNumber?: string
  hasStock: boolean
}

export interface EmployeeSource {
  sourceType: string
  sourceId?: string
}

export const genericAmplitudeProperties = (data: WizardData) => {
  const filledDataKeys = Object.keys(data).filter((key) => {
    const value = data[key as keyof WizardData]
    return !!value
  })

  return {
    completedFields: filledDataKeys,
    companyId: data.companyId,
    sourceType: data.source?.sourceType,
    legalEntityCountry: data.legalEntity?.country,
    legalEntityId: data.legalEntity?.id,
    hasPayrollApp: data.hasPayrollApp,
    contractIsDiscontinuous: data.contractIsDiscontinuous,
  }
}
